module.exports = __webpack_public_path__ + "template_design_facebook_microfence_digitalfactory.jpg?3a58c5c95af49f5074696f66368cd90d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/template_design_facebook_microfence_digitalfactory.jpg
// module id = 59
// module chunks = 0